export default __webpack_public_path__ + "static/media/call-icon-iacst.cecbde51.svg";